import React from "react";
import { SchoolWithExamRegistration } from "../../types/types";

interface FooterNotesProps {
  registrationData: SchoolWithExamRegistration | null;
}

const FooterNotes: React.FC<FooterNotesProps> = ({ registrationData }) => {
  return (
    <div className="gceo-footer-notes">
      <p className="gceo-note-text">
        <strong>NB: (i)</strong> When you choose a specialty e.g ACC and
        indicate the number of candidates, the professional subjects are known.
        But fill the total <strong>number of candidates</strong> for each{" "}
        <strong>general</strong> subject in the specialty.
      </p>
      <p className="gceo-note-text">
        <strong>(ii)</strong> Registering for this examination is tantamount to
        undertaking to strict respect of the Examination Timetable found at{" "}
        <strong>www.trunorthwest.net</strong>
      </p>
      <p className="gceo-note-text">
        <strong>(iii)</strong> Updates and modifications may be found in the{" "}
        <strong>
          NW MOCK{" "}
          {registrationData?.exam_session
            ? new Date(registrationData.exam_session.end_date).getFullYear()
            : "2026"}{" "}
          WhatsApp Forum
        </strong>
        . Ensure you are included in the forum after registration.
      </p>
    </div>
  );
};

export default FooterNotes;
